import React, { useState, useEffect } from 'react'
import { Box, Paper, Text, Divider, Group, Pagination, Flex } from '@mantine/core'
import { useParams } from 'react-router-dom'
import { getListUserOrdersHistory } from '../../../../../services/users'
import { useFilterUserOrders } from './schema/form'
import LoadingData from '../../../../ui/LoadingData'
import NoData from '../../../../ui/NoData'
import TableUserOrders from './TableUserOrders'

const labelTable = [
  {
    label: 'Order Code',
    width: 'auto'
  },
  {
    label: 'Date',
    width: 'auto'
  },
  {
    label: 'Customer Name',
    width: 'auto'
  },
  {
    label: 'Agent',
    width: 'auto'
  },
  {
    label: 'Sales',
    width: 'auto'
  },
  {
    label: 'Payment Status',
    width: 'auto'
  },
  {
    label: 'Order Status',
    width: 'auto'
  },
  {
    label: 'Grand Total',
    width: 'auto'
  },
  {
    label: 'Detail',
    width: 'auto'
  },
]

const UserOrders = () => {
  const params = useParams()
  const userId = params.id

  const [loadingData, setLoadingData] = useState(true)
  const [userOrders, setUserOrders] = useState([])
  const [totalOrders, setTotalOrders] = useState(0)

  const filterForm = useFilterUserOrders()

  const handleGetUserOrdersHistory = async () => {
    setLoadingData(true)
    const params = {
      ...filterForm.values,
      'filter[user_id][is]': userId,
    }
    try {
      const response = await getListUserOrdersHistory(params)
      if (response.success) {
        const { data, meta, included } = response

        const pickIncludedAgent = included.agent || []
        const pickIncludedSales = included.sales || []
        const pickIncludedOrderPaymentStatus = included.statuses || []
        console.log(pickIncludedOrderPaymentStatus)

        const getDataUser = (userId, included) => {
          let data = null
          const findUser = included[userId]
          if (findUser) {
            data = {
              id: findUser.attributes.id,
              name: findUser.attributes.name
            }
          }
          return data
        }

        const getDataOrderPaymentStatus = (orderPaymentStatusRelations, included, type) => {
          let data = null
          const remapData = orderPaymentStatusRelations.map((val) => {
            return included[val.id]
          })
          const findStatus = remapData.filter(val => val.attributes.type === type)[0]
          if (findStatus) {
            data = findStatus.attributes.name
          }
          return data
        }

        const remapData = data.map((val) => {
          const customerFirstName = val.attributes.order_infos.shipping.first_name
          const customerLastName = val.attributes.order_infos.shipping.last_name
          return {
            id: val.attributes.id,
            order_code: val.attributes.order_code,
            created_at: val.attributes.created_at,
            customer_name: customerFirstName && customerLastName ? `${customerFirstName} ${customerLastName}` : '-',
            agent: val.attributes.ordered_by_user_id ? getDataUser(val.attributes.ordered_by_user_id, pickIncludedAgent) : null,
            sales: val.relationships.sales ? getDataUser(val.relationships.sales.id, pickIncludedSales) : null,
            payment_status: val.relationships.statuses.length > 0 ? getDataOrderPaymentStatus(val.relationships.statuses, pickIncludedOrderPaymentStatus, 1) : null,
            order_status: val.relationships.statuses.length > 0 ? getDataOrderPaymentStatus(val.relationships.statuses, pickIncludedOrderPaymentStatus, 2) : null,
            grand_total: val.attributes.grand_total,
            order_currency: val.attributes.currency_order
          } 
        })

        setUserOrders(remapData)
        setTotalOrders(meta.pagination.total || 0)
      } else {
        setUserOrders([])
        setTotalOrders(0)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingData(false)
    }
  }

  useEffect(() => {
    handleGetUserOrdersHistory()
    // eslint-disable-next-line
  }, [filterForm.values])

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    filterForm.setValues((prev) => ({ ...prev, 'page[num]': val }) )
  }


  return (
    <Box>
      <Paper my='xl' p='md' withBorder shadow='xs' radius='md'>
        <Text fw={500}>
          Order History
        </Text>
        <Divider my='xs' />
        <Box my={20}>
          <Box>
            <Group mb={2} gap='xs'>
              <Text fz={12}>Order Total: </Text>
              <Text fz={12} fw='bold'>{totalOrders} Orders</Text>
            </Group>
          </Box>
          {loadingData ? <LoadingData /> : userOrders.length > 0 ? <TableUserOrders label={labelTable} data={userOrders} /> : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} total={Math.ceil(totalOrders / filterForm.values['page[limit]']) || 0} />
        </Flex>
      </Paper>
    </Box>
  )
}

export default UserOrders